import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import id from "./rsc/strings/id.json"
import en from "./rsc/strings/en-US.json"

const resources = {
  en: {
    translation: en
  },
  id: {
    translation: id
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "id",
    fallbackLng: "id",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;